var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.871,
    height: 10,
    viewBox: "0 0 16.871 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#007bf7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.944 -36.802)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44.618,41.417l-5.181-4.476a.569.569,0,0,0-.743.861l3.972,3.431H28.513a.569.569,0,0,0,0,1.137h14.3l-2.264,2.02-1.768,1.4a.568.568,0,1,0,.706.891l1.794-1.421,3.35-2.988a.567.567,0,0,0-.007-.854Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.4fe81c40b24dfd5eaf66b19df53c4222.svg";
export { ForwardRef as ReactComponent };